import { jsxs as s, jsx as o } from "react/jsx-runtime";
const t = (e) => /* @__PURE__ */ s(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ s("g", { clipPath: "url(#opera-colored_svg__a)", children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#opera-colored_svg__b)",
            d: "M8.05 18.763c-1.328-1.567-2.187-3.88-2.244-6.48v-.566c.057-2.6.916-4.913 2.244-6.48 1.723-2.235 4.281-3.653 7.137-3.653 1.757 0 3.403.538 4.81 1.471A11.95 11.95 0 0 0 12.046 0H12C5.374 0 0 5.374 0 12c0 6.437 5.066 11.688 11.429 11.986Q11.713 24 12 24c3.072 0 5.875-1.154 7.997-3.053a8.67 8.67 0 0 1-4.81 1.469c-2.856 0-5.414-1.418-7.137-3.653"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#opera-colored_svg__c)",
            d: "M8.05 5.237c1.101-1.301 2.522-2.083 4.077-2.083 3.495 0 6.324 3.96 6.324 8.846s-2.832 8.846-6.324 8.846c-1.552 0-2.976-.784-4.077-2.083 1.723 2.235 4.281 3.653 7.137 3.653a8.68 8.68 0 0 0 4.81-1.469A11.97 11.97 0 0 0 24 12c0-3.554-1.545-6.749-4.003-8.945a8.65 8.65 0 0 0-4.81-1.471c-2.856 0-5.414 1.418-7.137 3.653"
          }
        )
      ] }),
      /* @__PURE__ */ s("defs", { children: [
        /* @__PURE__ */ s(
          "linearGradient",
          {
            id: "opera-colored_svg__b",
            x1: 9.999,
            x2: 9.999,
            y1: 0.391,
            y2: 23.651,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { offset: 0.3, stopColor: "#FF1B2D" }),
              /* @__PURE__ */ o("stop", { offset: 0.438, stopColor: "#FA1A2C" }),
              /* @__PURE__ */ o("stop", { offset: 0.594, stopColor: "#ED1528" }),
              /* @__PURE__ */ o("stop", { offset: 0.758, stopColor: "#D60E21" }),
              /* @__PURE__ */ o("stop", { offset: 0.927, stopColor: "#B70519" }),
              /* @__PURE__ */ o("stop", { offset: 1, stopColor: "#A70014" })
            ]
          }
        ),
        /* @__PURE__ */ s(
          "linearGradient",
          {
            id: "opera-colored_svg__c",
            x1: 16.025,
            x2: 16.025,
            y1: 1.762,
            y2: 22.334,
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ o("stop", { stopColor: "#9C0000" }),
              /* @__PURE__ */ o("stop", { offset: 0.7, stopColor: "#FF4B4B" })
            ]
          }
        ),
        /* @__PURE__ */ o("clipPath", { id: "opera-colored_svg__a", children: /* @__PURE__ */ o("path", { fill: "#fff", d: "M0 0h24v24H0z" }) })
      ] })
    ]
  }
);
export {
  t as default
};
